import { Component, input } from '@angular/core';
import { IDisplayInfoConfig, IDisplayInfoField } from './display-info.model';
import { NgTemplateOutlet } from '@angular/common';
import { DisplayInfoFieldPipe } from '../../pipes';
import { LocalizationPipe } from '@shared/modules/localization';

@Component({
  selector: 'pkp-g-display-info',
  templateUrl: './display-info.component.html',
  styleUrl: './display-info.component.scss',
  imports: [NgTemplateOutlet, DisplayInfoFieldPipe, LocalizationPipe],
})
export class DisplayInfoComponent {
  config = input<IDisplayInfoConfig>();

  isFieldHidden(field: IDisplayInfoField): boolean {
    if (field.hidden === undefined) {
      return false;
    }
    return typeof field.hidden === 'function' ? field.hidden() : field.hidden;
  }
}
